<template>
  <div>
    <!-- <div class="filterButtonPosition" style="right: 64px">
      <f7-button
        fill
        class="whiteFontColor button-filter"
        panel-toggle="right"
      >
        <span class="ic-filter"></span> {{ $t('filter') }}
      </f7-button>
    </div> -->
    <DxDataGrid
      ref="dataGrid"
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataTextDetail')"
      class="custom-grid custom-grid-detail-environment"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
      @content-ready="init"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="environmentSamplesDetailsTable_v2"
      />
      <DxSelection mode="single" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />
      <DxSearchPanel
        :visible="true"
        :width="239"
        :placeholder="$t('search')"
      />
      <DxExport :enabled="true" />

      <DxColumn
        data-field="cma_is_apt"
        caption=""
        header-cell-template="cellTemplateHeaderDots"
        :width="35"
        :allow-sorting="false"
        cell-template="cellTemplateDots"
        :fixed="true"
        fixed-position="left"
      />
      <template #cellTemplateDots="{ data }">
        <div class="dots-parent-container">
          <img width="20" height="20" :src="getDotColorImage(data)" />
        </div>
      </template>
      <DxColumn
        data-field="parameter_group"
        :caption="$t('group')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parameter"
        :caption="$t('foodSamples.parameter')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="result_value"
        cell-template="cellTemplateResultadoPresentacion"
        :caption="$t('foodSamples.result')"
        :calculate-cell-value="calculateResultValue"
        :allow-header-filtering="false"
      />

      <template #cellTemplateResultadoPresentacion="{ data }">
        <div>
          {{
            data.data.value.ResultadoPresentacion.includes(
              'En Proceso'
            )
              ? $t('inProcess')
              : data.data.value.ResultadoPresentacion
          }}
        </div>
      </template>

      <DxColumn
        data-field="unit_value"
        :caption="$t('foodSamples.unit')"
        alignment="left"
        :calculate-cell-value="calculateUnitValue"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="range_value"
        :caption="$t('foodSamples.range')"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateRange"
      />

      <DxColumn
        data-field="cma_value"
        :caption="$t('cma')"
        alignment="left"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateCma"
      />

      <template #cellTemplateHeaderDots="{ data }">
        <div>
          <PopUp position="top">
            <div style="padding: 10px">
              <div class="pop-up-info">
                <img
                  :src="getDotImage('grey')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('environmentSamples.detail.greyDotDescription')
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('green')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t(
                      'environmentSamples.detail.greenDotDescription'
                    )
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('red')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('environmentSamples.detail.redDotDescription')
                  }}
                </div>
              </div>
            </div>
          </PopUp>
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
  DxSelection,
} from 'devextreme-vue/data-grid';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import PopUp from '@/components/UtilityComponents/popUpInfo/popUp.vue';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
    DxSelection,
    PopUp,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    environmentSamplesDetails() {
      return this.filteredSampleDetails !== null
        ? this.filteredSampleDetails
        : this.sampleDetails;
    },
    ...mapState('environmentSamples', [
      'sampleDetails',
      'filteredSampleDetails',
    ]),
    ...mapState('samples', ['reportSampleCode']),
  },
  methods: {
    getDotImage(color) {
      return require(`../../../../../assets/dot-colors/${color}_new.svg`)
        .default;
    },
    getDotColorImage(data) {
      if (!data.value && data.value !== false) {
        return require(`../../../../../assets/dot-colors/grey_new.svg`)
          .default;
      }
      if (data.value === false) {
        return require(`../../../../../assets/dot-colors/red_new.svg`)
          .default;
      }
      return require(`../../../../../assets/dot-colors/green_new.svg`)
        .default;
    },
    calculateRange(rowData) {
      return `${rowData.value.r_min} - ${rowData.value.r_max}`;
    },
    calculateUnitValue(rowData) {
      return rowData?.value?.unit ?? '';
    },
    calculateResultValue(rowData) {
      return rowData?.value?.ResultadoPresentacion ?? '';
    },
    calculateCma(rowData) {
      return rowData.cma?.[0]?.CMASuperior ?? '';
    },
    init(e) {
      this.setSampleDetails(e.component.getDataSource().items());
    },
    async onExporting(e) {
      this.setIsExporting(true);
      e.component.beginUpdate();
      e.component.columnOption('ID', 'visible', true);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(
        this.$t('environmentSamples.exportExcelName')
      );

      exportDataGrid({
        component: e.component,
        worksheet,
      })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], {
                type: 'application/octet-stream',
              }),
              `besafer-${this.reportSampleCode}.xlsx`
            );
          });
        })
        .then(() => {
          e.component.columnOption('ID', 'visible', false);
          e.component.endUpdate();
        });

      e.cancel = true;
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'after';
        }
        if (item.name === 'exportButton') {
          item.location = 'after';
        }

        // if (item.name === 'groupPanel') {
        //   item.location = 'after';
        // }
      });
      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Filtros',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: '',
          icon: '././static/icons/ic_filter.svg',
          width: 40,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    ...mapActions('environmentSamples', [
      'setSampleDetails',
      'setIsExporting',
    ]),
  },
};
</script>

<style>
/* ::v-deep .dx-toolbar-after {
  left: initial !important;
} */
.custom-grid-detail-environment .dx-toolbar-after {
  display: grid;
  grid-template-columns: 100px 107px 48px 37px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-detail-environment .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
}
.custom-grid-detail-environment .dx-toolbar-after :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-detail-environment .dx-toolbar-after :nth-child(3) {
  grid-row: 1;
  grid-column: 3;
  justify-self: start;
}

.custom-grid-detail-environment .dx-searchbox {
  width: 200px !important;
}

/* === Ajuste visual del buscador y botón de filtro en Environment === */
.custom-grid-detail-environment .dx-datagrid-search-panel.dx-textbox {
  height: 40px !important;
  border: 1px solid #00346a !important;
  border-radius: 24px !important;
  background: #fff !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
}

/* Contenedor interno del buscador (elimina espacios que lo desalinean) */
.custom-grid-detail-environment
  .dx-datagrid-search-panel
  .dx-texteditor-container {
  margin: 0 !important;
  padding: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
}

/* === Botón de filtro === */
.custom-grid-detail-environment .dx-toolbar-after .dx-button {
  height: 40px !important; /* igual altura que el search */
  width: 40px !important;
  border-radius: 10px !important;
  border: 1px solid #00346a !important;
  background-color: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
}

/* Centrado perfecto del icono dentro del botón */
.custom-grid-detail-environment
  .dx-toolbar-after
  .dx-button
  .dx-button-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Asegura que el icono esté centrado exactamente */
.custom-grid-detail-environment
  .dx-toolbar-after
  .dx-button
  .dx-icon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  top: 0 !important; /* si aún parece ligeramente alto, usa top: 1px */
  color: #00346a !important;
  font-size: 16px !important;
}

/* Input más grande */
.custom-grid-detail-environment .dx-searchbox .dx-texteditor-input {
  padding-left: 36px !important;
  height: 40px !important;
  line-height: 40px !important;
}

/* Contenedor */
.custom-grid-detail-environment .dx-searchbox {
  position: relative;
  height: 40px !important;
}

/* ICONO */
.custom-grid-detail-environment .dx-searchbox::before {
  content: '';
  position: absolute;

  left: 7px;
  top: 45%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;

  background-image: url('@/static/icons/ic_search_blue.svg');
  background-repeat: no-repeat;
  background-size: 24px 24px;

  pointer-events: none;
}
</style>
